module.exports = __webpack_public_path__ + "img/product_42.69f990f.webp";